import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=5f11c122&scoped=true&"
import script from "./AccountManage.vue?vue&type=script&lang=js&"
export * from "./AccountManage.vue?vue&type=script&lang=js&"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=5f11c122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11c122",
  null
  
)

export default component.exports